import DOMPurify from "dompurify";

DOMPurify.addHook("afterSanitizeAttributes", (node) => {
	if (node instanceof HTMLAnchorElement) {
		node.setAttribute("target", "_blank");
		node.setAttribute("rel", "noopener noreferrer");
	}
});

export function sanitizeRichHtml(html: string): string {
	return DOMPurify.sanitize(html, { ADD_ATTR: ["target"] });
}
